import React, { useState } from 'react'
import {
  Wrapper,
  Title,
  Button,
  ModalContent,
  TitleModal,
  Description,
  StepsWrapper,
  MoreText,
  CombinedText,
} from './styled'
import ModalFromBottom from 'components/base-ui/ModalFromBottom'
import Icon from 'components/base-ui/Icon'
import StepItem from 'components/base-ui/StepItem'
import { useTranslation } from 'react-i18next'

interface InstructionCombineCouponProps {
  onClickCombineCoupon: VoidFunction
}
const InstructionsCombineCoupon = ({ onClickCombineCoupon }: InstructionCombineCouponProps) => {
  const [showModal, setShowModal] = useState(false)
  const { t } = useTranslation()

  const shareCouponSteps = [
    {
      title: t('dineIn.shareCouponPage.steps.step1.title'),
      descirption: t('dineIn.shareCouponPage.steps.step1.description'),
    },
    {
      title: t('dineIn.shareCouponPage.steps.step2.title'),
      descirption: t('dineIn.shareCouponPage.steps.step2.description'),
    },
    {
      title: t('dineIn.shareCouponPage.steps.step3.title'),
      descirption: t('dineIn.shareCouponPage.steps.step3.description'),
    },
  ]

  return (
    <>
      <Wrapper>
        <Title>{t('dineIn.shareCouponPage.instructions.title')}</Title>
        <MoreText onClick={() => setShowModal(true)}>{t('dineIn.shareCouponPage.instructions.more')}</MoreText>
        <Button xtra_sm onClick={onClickCombineCoupon}>
          <Icon name="person-add" size="18px" />
          <CombinedText> {t('dineIn.shareCouponPage.instructions.combind')}</CombinedText>
        </Button>
      </Wrapper>
      <ModalFromBottom
        isOpen={showModal}
        hideCloseButton={false}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick
        btnClose={null}
        zindex={100}
        style={{ padding: '16px 20px' }}
      >
        <ModalContent>
          <TitleModal>
            <Icon name="person-add" size="24px" />
            {t('dineIn.shareCouponPage.steps.title')}
          </TitleModal>
          <Description>{t('dineIn.shareCouponPage.steps.description')}</Description>
          <StepsWrapper>
            {shareCouponSteps.map(({ title, descirption }, index) => (
              <StepItem stepNumber={index + 1} title={title} description={descirption} />
            ))}
          </StepsWrapper>
        </ModalContent>
      </ModalFromBottom>
    </>
  )
}

export default InstructionsCombineCoupon
